import {GET, POST} from '../index'
// 获取游戏列表
export const getList = (data) => {
  return POST('/game/list', data)
}

// 更新指定状态
export const changeStatus = (data) => {
  return POST('/game/change/status', data)
}

// 添加游戏
export const addGame = (data) => {
  return POST('/game/add', data)
}

// 更改排序
export const storeSort = (data) => {
  return POST('/game/sort', data)
}

// 获取基本数据
export const getInfo = (data) => {
  return GET('/game/info', data)
}

// 更改基本数据
export const editInfo = (data) => {
  return POST('/game/edit/info', data)
}

// 获取图片数据
export const getImgInfo = (data) => {
  return GET('/game/img', data)
}
// 更改图片数据
export const setGameImg = (data) => {
  return POST('/game/set/img', data)
}



// WEBPACK FOOTER //
// ./src/api/game/index.js